<form class="row gy-3 gx-3" [formGroup]="form">
  <ng-container formArrayName="flights">
    <ng-container *ngFor="let flight of getFlights().controls; let i = index">
      <div class="col-md-4 col-sm-12 col-xl-4">
        <div class="location-selector-container px-3">
          <div class="item">
            <fa-icon [icon]="icons.departure"></fa-icon>
          </div>
          <div class="item w-90">
            <div [id]="i+'flightFrom'" data-bs-toggle="dropdown" class="form-input w-100">
              <div class=" ">
                <app-airports-deropdown [formGrp]="getFlightFormGroup(i)"
                  formCtrlName="flightFrom"></app-airports-deropdown>
              </div>
            </div>
            <ul [attr.aria-labelledby]="i+'flightFrom'" class="dropdown-menu customer-dropdown p-0">
              <li *ngFor="let airport of airportFromAutoComplete" (click)="selectAirport(airport, i)"
                class="d-flex drop-item cur-pnt  align-items-center px-2 py-3">
                <fa-icon [icon]="icons.planeUp"></fa-icon>
                <h6 class="dropdown-text">{{ '('+ airport?.iata + ') ' + airport.airport}}</h6>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="col-md-4 col-sm-12 col-xl-4">
        <div class="location-selector-container px-3">
          <div class="item">
            <fa-icon [icon]="icons.arrival"></fa-icon>
          </div>
          <div class="item w-90">
            <div [id]="i+'flightTo'" data-bs-toggle="dropdown" class="form-input w-100">
              <div class=" ">
                <app-airports-deropdown [placeholder]="'Going To?'" [formGrp]="getFlightFormGroup(i)"
                  formCtrlName="flightTo"></app-airports-deropdown>
              </div>
            </div>
            <ul [attr.aria-labelledby]="i+'flightFrom'" class="dropdown-menu customer-dropdown p-0">

              <li *ngFor="let airport of airportToAutoComplete" (click)="selectToAirport(airport, i)"
                class="d-flex drop-item cur-pnt  align-items-center px-2 py-3">
                <fa-icon [icon]="icons.planeUp"></fa-icon>
                <h6 class="dropdown-text">{{ '('+ airport?.iata + ') ' + airport.airport}}</h6>

              </li>
            </ul>
          </div>

        </div>
      </div>
      <div [formGroupName]="i" class="col-md-3 col-sm-11" [ngClass]="{'col-md-4 col-sm-12': i==0}">
        <div class="range-section px-3">
          <fa-icon class="icon-btn" (click)="dp.toggle()" [icon]="icons.calendar"></fa-icon>
          <input formControlName="date" class="date-picker-input" type="text" placeholder="Leaving"
            [minDate]="i==0 ? minDate : form.value.flights[i-1].date"
            [bsConfig]="{ isAnimated: true, showWeekNumbers: false, rangeInputFormat: 'DD-MM-YYYY', dateInputFormat: 'ddd, MMMM Do' }" #dp="bsDatepicker"
            bsDatepicker>
          <fa-icon class="icon-btn" (click)="dp.toggle()" [icon]="icons.caretDown"></fa-icon>
        </div>
      </div>

      <div class="col-md-1 d-flex align-items-center" *ngIf="i!==0">
        <fa-icon class="icon-btn" (click)="removeFlight(i)" [icon]="icons.times" size="2x"></fa-icon>
      </div>
    </ng-container>
  </ng-container>


  <div class="col-md-12 col-sm-12 d-flex">
    <button [disabled]="getFlights().controls.length == 5" (click)="addFlight()" class="show-more">
      Add Another Flight
    </button>
  </div>
  <div class="guest-section col-md-4 col-6 col-xl-4">
    <div class="">
      <div class="d-flex flex-row align-items-center" data-bs-toggle="dropdown">
        <fa-icon class="pt-3 pt-md-0" [icon]="icons.users"></fa-icon>
        <input [formControlName]="'occupants'" class="guest-input" type="text" placeholder="Guests">
        <fa-icon class="pt-3 pt-md-0" [icon]="icons.caretDown"></fa-icon>
      </div>
      <ul class="dropdown-menu" (click)="$event.stopPropagation()">
        <div *ngFor="let occupant of occupant_types" class="d-flex justify-content-between align-items-center pb-3">
          <div class="d-flex align-items-center">
            <fa-icon class="dropdown-icon occupants-icon me-3" [icon]="occupant.icon"></fa-icon>
            <div>
              <h6 class="dropdown-text">{{occupant.name}}</h6>
              <small class="dropdown-subtext">{{occupant.subText}}</small>
            </div>
          </div>
          <div class="d-flex align-items-center">
            <fa-icon (click)="decrement(occupant.name)" class="dropdown-icon dropdown-caret" [icon]="icons.caretDown">
            </fa-icon>
            <input [formControlName]="occupant.name" (keyup)="constructString()" class="dropdown-input" type="number"
              placeholder="0">
            <fa-icon (click)="increment(occupant.name)" class="dropdown-icon dropdown-caret" [icon]="icons.caretUp">
            </fa-icon>
          </div>
        </div>
      </ul>
    </div>
  </div>

  <div class="col-md-4 col-6 col-xl-4">
    <div class="cabin-section" [formGroup]="form">
      <select id="" class="cabin-input" formControlName="cabin">
        <!-- <option selected value="">Cabin</option> -->
        <option value="economy">Economy</option>
        <option value="premium">Premium Economy</option>
        <option value="business">Business</option>
        <option value="first">First Class</option>
      </select>
      <fa-icon [icon]="icons.caretDown"></fa-icon>
    </div>
  </div>
  <div class="col-md-4 col-sm-12 col-xl-4">
    <div class="search-button w-100 h-100">
      <app-button class="w-100 h-100" [className]="'w-100 h-100'"
        [disabled]="!form.valid || form.controls['adults'].value <1" (onclick)="search()" warning>Search</app-button>
    </div>
  </div>
</form>
